import FooterMobile from "./FooterMobile";

export default FooterMobile;
